export class InvalidParameterError extends Error {
    constructor(ffor:string,expected:string,given:string){
        super(`Invalid parameter provided for ${ffor}. Expected ${expected}, but got ${given}`); 
    }
}